// removed by extract-text-webpack-plugin
module.exports = {"colorPicker":"ColorPicker__colorPicker___Ba2c4","label":"ColorPicker__label___qllKa","node":"ColorPicker__node___1S_Kr","colorSwatch":"ColorPicker__colorSwatch___2ZTbL","colorLabel":"ColorPicker__colorLabel___3tcKv","SketchPicker":"ColorPicker__SketchPicker___1MclT","flexbox-fit":"ColorPicker__flexbox-fit___cAcAi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ColorPicker/ColorPicker.scss
// module id = 266
// module chunks = 0